export default __webpack_public_path__ + "static/media/Path3434.3eb16232.svg";